import { IFieldConfigurationObject, IFieldGroup } from "AngularFormly";
import { IWorkItemScope, WorkItemController } from "../workItemController";
import {
  WorkItemService,
  vsServiceName as WorkItemServiceName,
} from "../service";
import { InfoListFieldTypeController } from "./fieldTypes/info/infoController";
import { vsWrapperName as labelWrapper } from "../wrappers/label";
import { ConfirmationListFieldTypeController } from "./fieldTypes/confirmation/confirmationController";
import { TextListFieldTypeController } from "./fieldTypes/text/textController";

export interface ListField {
  Key: string;
  DisplayText: string;
  Type: "Info" | "Confirmation" | "Text";
}

interface IItemContext {
  model: any;
  listFields: ListField[];
  formlyFields: IFieldGroup[];
}

export class ListController extends WorkItemController {
  static $inject = ["$scope", WorkItemServiceName];
  itemContexts: IItemContext[] = [];

  constructor(
    $scope: IWorkItemScope,
    private readonly workItemService: WorkItemService
  ) {
    super($scope);
    this.$scope.model!.value ??= [];

    this.itemContexts = this.initializeContexts();
  }

  get items(): any[] {
    return this.$scope.model!.value;
  }

  initializeContexts(): IItemContext[] {
    const field = this.field;
    const listFields = <ListField[]>(field.Options?.ListFields ?? []);
    const contexts = this.items.map(
      (i) =>
        <IItemContext>{
          field,
          formlyFields: this.getFormFields(listFields),
          listFields: listFields,
          model: i,
        }
    );

    return contexts;
  }

  private getFormFields(listFields: ListField[]): IFieldGroup[] {
    const formlyFields = listFields.map((lf) =>
      this.getFormlyFieldForListField(lf)
    );
    const fieldGroups = this.workItemService.doLayout(formlyFields);
    return fieldGroups;
  }

  getFormlyFieldForListField(lf: ListField): IFieldConfigurationObject {
    const type = lf.Type;
    const { controller, template } =
      this.getListFieldControllerAndTemplate(type);

    const formlyField: IFieldConfigurationObject = {
      controller,
      template,
      id: lf.Key,
      key: lf.Key,
      data: {
        workItemController: this,
        field: lf,
      },
      wrapper: [labelWrapper],
      templateOptions: {
        Text: lf.DisplayText,
      },
    };
    return formlyField;
  }

  getListFieldControllerAndTemplate(type: string): {
    controller: Function;
    template: string;
  } {
    switch (type) {
      case "Info":
        return {
          controller: InfoListFieldTypeController,
          template: require("!html-loader!./fieldTypes/info/index.html")
            .default,
        };
      case "Confirmation":
        return {
          controller: ConfirmationListFieldTypeController,
          template: require("!html-loader!./fieldTypes/confirmation/index.html")
            .default,
        };
      case "Text":
        return {
          controller: TextListFieldTypeController,
          template: require("!html-loader!./fieldTypes/text/index.html")
            .default,
        };
      case "Url":
        return {
          controller: InfoListFieldTypeController,
          template: require("!html-loader!./fieldTypes/url/index.html").default,
        };
      default:
        throw new Error("Couldn't find list field info");
    }
  }
}
